module.exports = __webpack_public_path__ + "img/logo_sem.48566485.jpg";